import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useSidebarContext } from "../SidebarContext";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children, showVerseSettings }) => {
  const [selectedTab, setSelectedTab] = useState("general");
  const intl = useIntl();
  const { sidebarId, setSidebar } = useSidebarContext();

  const open = useMemo(() => sidebarId === "room-settings", [sidebarId]);
  const setOpen = useCallback(open => setSidebar(open ? "room-settings" : ""), [setSidebar]);

  const tabs = useMemo(
    () => [
      {
        value: "general",
        content: intl.formatMessage({ id: "room-settings-sidebar.general", defaultMessage: "General" })
      },
      {
        value: "audiovideo",
        content: intl.formatMessage({ id: "room-settings-sidebar.audio-and-video", defaultMessage: "Audio & Video" })
      },
      {
        value: "graphics",
        content: intl.formatMessage({ id: "room-settings-sidebar.graphics", defaultMessage: "Graphics" })
      },
      {
        value: "controls",
        content: intl.formatMessage({ id: "room-settings-sidebar.controls", defaultMessage: "Controls" })
      }
    ],
    [intl]
  );

  useEffect(() => {
    if (showVerseSettings) {
      tabs.unshift({
        value: "verse",
        content: intl.formatMessage({ id: "room-settings-sidebar.verse", defaultMessage: "Verse" })
      });
    }
  }, [showVerseSettings, intl, tabs]);

  useEffect(() => {
    setSelectedTab(tabs[0].value);
  }, [tabs]);

  const onOpenChange = useCallback(
    open => {
      setOpen(open);
    },
    [setOpen]
  );
  const onTabChange = useCallback(tab => setSelectedTab(tab), []);

  return (
    <SettingsContext.Provider value={{ tabs, open, onOpenChange, selectedTab, onTabChange, showVerseSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

SettingsProvider.propTypes = {
  children: PropTypes.node,
  showVerseSettings: PropTypes.bool
};

export const useSettingsContext = () => useContext(SettingsContext);
